gl-legend-item .item ion-thumbnail {
  height: 40px;
  width: 40px;
}
